import { c as _c } from "react/compiler-runtime";
import queryString from 'query-string';
import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
const usePDPUpdateQueryParams = () => {
  const $ = _c(2);
  const history = useHistory();
  let t0;
  if ($[0] !== history) {
    t0 = (selectedOption, optionValue) => {
      const {
        pathname: t1,
        search: t2
      } = typeof window === "undefined" ? history.location ?? {} : window.location;
      const pathname = t1 === undefined ? "" : t1;
      const queryParamsString = t2 === undefined ? "" : t2;
      const selectedOptionName = selectedOption?.name?.replace(/[_-\s]/g, "_").replace("rugs", "size").toLowerCase();
      const selectedOptionAlternateName = selectedOption?.original_name?.replace(/[_-\s]/g, "_").toLowerCase() || "";
      const selectedOptionValue = optionValue?.value?.trim().replace(/[_-\s]/g, "_").toLowerCase();
      const queryParams = queryString.parse(queryParamsString);
      const updatedQueryParams = queryString.stringify({
        ...queryParams,
        ...(queryParams[selectedOptionAlternateName] ? {
          [selectedOptionAlternateName]: selectedOptionValue
        } : {
          [selectedOptionName]: selectedOptionValue
        })
      });
      if (updatedQueryParams !== queryParamsString?.replace("?", "")) {
        if (pathname?.includes?.("/compare")) {
          history.replace?.({
            pathname: `${pathname?.split("/compare")[0]}`,
            search: updatedQueryParams
          });
        } else {
          history.replace?.({
            search: updatedQueryParams
          });
        }
      }
    };
    $[0] = history;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const updateUrlQueryParams = t0;
  return updateUrlQueryParams;
};
export default usePDPUpdateQueryParams;